import React from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Container, Typography, Button, Box } from "@mui/material";

const SuccessPayment = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const transactionId = searchParams.get("transactionId");
    const amount = searchParams.get("amount");

    return (
        <Container maxWidth="sm">
            <Box sx={{ textAlign: "center", mt: 8 }}>
                <Typography variant="h3" color="success.main" gutterBottom>
                    🎉 Płatność zakończona sukcesem! 🎉
                </Typography>
                <Typography variant="body1" paragraph>
                    Dziękujemy za dokonanie płatności. Twoja transakcja została pomyślnie zakończona.
                </Typography>

                {transactionId && (
                    <Typography variant="body1">
                        <strong>ID transakcji:</strong> {transactionId}
                    </Typography>
                )}
                {amount && (
                    <Typography variant="body1">
                        <strong>Kwota:</strong> {(amount / 100).toFixed(2)} PLN
                    </Typography>
                )}

                <Box mt={4}>
                    <Button
                        variant="contained"
                        color="primary"
                        size="large"
                        onClick={() => navigate("/")}
                    >
                        Powrót do strony głównej
                    </Button>
                </Box>
            </Box>
        </Container>
    );
};

export default SuccessPayment;